exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer\r\n{\r\n    margin-top: 0px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main